export enum PreferCallingPlatformEnum
{
    Phone = 1,
    Terminal = 2,
    CustomPhone = 3,
    Email = 4,
    Zoom = 5,
}